$(document).ready(function(){
    $('.header-popup-close').click(function(){ 
        $('#header-popup').fadeOut(); 
    });
    $('.menu_openner').click(function(){ 
        $('#header-popup').fadeIn(); 
    }); 
});


/**
 * Standard Scroll Reveal Animation Engine (IntersectionObserver)
 * Follows Web Standards (AOS / Shopify Theme Conventions)
 */

function initScrollReveal() {
  const selectors = [
    '[data-animate]',
    '.scroll-reveal',
    '.scroll-reveal-left',
    '.scroll-reveal-right',
    '.scroll-reveal-zoom',
    '.wpt-up',
    '.wpt-item',
    '.shadow_half_right',
    '.shadow_half_left',
    '.shadow_half_middle_left',
    '.shadow_half_middle_right',
    '.shadow-half-backdrop',
    'section[id^="wtj-section-"]'
  ];

  const elements = document.querySelectorAll(selectors.join(', '));
  if (!elements.length) return;

  const observer = new IntersectionObserver((entries, observerInstance) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const target = entry.target;
        const delay = target.getAttribute('data-delay') || 0;

        if (delay) {
          setTimeout(() => {
            target.classList.add('is-visible', 'wpt-up-show', 'wpt-item-show');
          }, parseInt(delay, 10));
        } else {
          target.classList.add('is-visible', 'wpt-up-show', 'wpt-item-show');
        }

        observerInstance.unobserve(target); // Animate once
      }
    });
  }, {
    root: null,
    rootMargin: '0px', // Matches TAU offset: "100%" (triggers immediately when element touches bottom of screen)
    threshold: 0
  });

  elements.forEach((el) => observer.observe(el));
}

// Initialize on DOM Ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollReveal);
} else {
  initScrollReveal();
}

// Re-initialize when Shopify Theme Editor updates sections
document.addEventListener('shopify:section:load', initScrollReveal);